import FormControl from "../control";

class Input extends FormControl {
    init(element) {
        this.setRootElement(element);

        if (!!this.element) {
            this.type = this.getControlType();
            this.validationType = this.type;

            if (this.type === 'date' || this.type === 'checkbox' || this.type === 'radio') {
                console.warn(`Input with ${this.type} type not fully supported by this class, please use specific ${this.type} control.`)
            }

            super.init();
        }
    }

    setRootElement(element) {
        this.element = element || document.querySelector('.js-input');
    }

    getControlType() {
        return this.getControlElement().getAttribute('type') || 'text';
    }
}

export default Input;